<template>
    <div class="quiz__nav">
        <button @click="back" class="quiz__nav-btn --back">BACK</button>
        <button @click="next" class="quiz__nav-btn --next" :class="{ '--enabled': !answer_needed }" v-show="final_question">SEE RESULTS</button>
        <button @click="next" class="quiz__nav-btn --next" :class="{ '--enabled': !answer_needed }" v-show="!final_question">NEXT</button>
    </div>
</template>

<script>
import { bus } from '../utilities'
import { analytics } from 'shiseido-apis'

export default {
    name: 'QuizNav',
    data() {
        return {
            answer: null,
            age: null,
            gender: null,
        }
    },
    computed: {
        answer_needed() {
            return this.answer === null
        },
        final_question() {
            return this.$route.name === 'preferred-texture'
        },
    },
    created() {
        bus.$on('answer::chosen', (answer) => {
            this.answer = answer
        })
        bus.$on('answer::chosen_age', (age) => {
            this.age = age
        })
        bus.$on('answer::chosen_gender', (gender) => {
            this.gender = gender
        })
    },
    methods: {
        next() {
            if (!this.answer_needed) {
                analytics.registerClick({
                    element: 'next',
                    toolname: 'Skincare Consultation',
                    question: this.$route.name,
                    answers: [this.answer],
                })

                const next_path = this.$route.path.concat(`/${ this.answer }`).replace(/\/\//g, '/')

                bus.$emit('next', next_path)
                bus.$emit('navigate::forward')

                this.answer = null
            }
        },
        back() {
            analytics.registerClick({
                element: 'back',
                toolname: 'Skincare Consultation',
                question: this.$route.name,
                answers: [],
            })

            this.answer = null

            if (this.$route.name.match(/life-style/)) {
                bus.$emit('next', '/')
                bus.$emit('navigate::back')
            } else {
                const curr_path  = this.$route.fullPath.replace(/\/$/, '')
                const curr_steps = curr_path.split('/')
                const prev_steps = curr_steps.slice(0, -1)
                const next_path  = prev_steps.join('/')

                bus.$emit('next', next_path)
                bus.$emit('navigate::back')
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/quiz-nav.vue